import { blogEmpresarialArticulosBody } from "./blogEmpresarialArticulosBody";
import {
  blogEmpresarialCategoryImages,
  blogEmpresarialCoverImages,
} from "./blogEmpresarialImages";

export const blogEmpresarialCategories = {
  "gestion-administrativa": {
    slug: "gestion-administrativa",
    title: "Gestión administrativa",
    subtitle: "Buenas prácticas de gobierno, operación y planeación para equipos directivos y administradores.",
    ...blogEmpresarialCategoryImages["gestion-administrativa"],
  },
  "transformacion-digital": {
    slug: "transformacion-digital",
    title: "Transformación digital",
    subtitle: "Automatización, datos e inteligencia artificial aplicados a procesos empresariales reales.",
    ...blogEmpresarialCategoryImages["transformacion-digital"],
  },
  "finanzas-corporativas": {
    slug: "finanzas-corporativas",
    title: "Finanzas corporativas",
    subtitle: "Tesorería, capital de trabajo y herramientas para sostener la liquidez de la empresa.",
    ...blogEmpresarialCategoryImages["finanzas-corporativas"],
  },
  "estrategia-comercial": {
    slug: "estrategia-comercial",
    title: "Estrategia comercial",
    subtitle: "Precios, mercados internacionales y decisiones comerciales con enfoque de rentabilidad.",
    ...blogEmpresarialCategoryImages["estrategia-comercial"],
  },
};

const autor = "Equipo MEU Aliado Empresas";

const blogEmpresarialArticlesBase = [
  {
    slug: "proceso-disciplinario-reforma-laboral-2026",
    category: "gestion-administrativa",
    title: "Proceso disciplinario laboral: cómo ajustarlo según la reforma de 2025",
    date: "20 abril 2026",
    publishedAt: "2026-04-20",
    readTime: "9 minutos",
    author: autor,
    featured: true,
    excerpt:
      "La Ley 2466 exige actualizar el RIT antes del 25 de junio de 2026 con un procedimiento disciplinario completo. Conozca principios, etapas, errores frecuentes y cómo socializar el reglamento sin riesgos legales.",
    content: [],
  },
  {
    slug: "contrato-aprendizaje-practicas-empresas-2026",
    category: "gestion-administrativa",
    title: "Contrato de aprendizaje y prácticas laborales en 2026: guía para empresas",
    date: "13 abril 2026",
    publishedAt: "2026-04-13",
    readTime: "9 minutos",
    author: autor,
    featured: false,
    excerpt:
      "La reforma laboral y el Decreto 0223 de 2026 redefinen cómo vincular aprendices del SENA y practicantes universitarios. Conozca obligaciones, costos, cuotas y buenas prácticas para cumplir sin fricción operativa.",
    content: [],
  },
  {
    slug: "plan-atraccion-talento-sostenible-negocio",
    category: "gestion-administrativa",
    title: "Cómo diseñar un plan de atracción de talento sostenible para su negocio",
    date: "17 marzo 2026",
    publishedAt: "2026-03-17",
    readTime: "8 minutos",
    author: autor,
    featured: false,
    excerpt:
      "La queja de que «no hay talento» suele esconder un proceso de selección sin estructura. Aprenda a construir un sistema de atracción basado en resultados, liderazgo alineado y estrategias que reduzcan rotación y costo.",
    content: [],
  },
  {
    slug: "convenios-doble-tributacion-empresas-colombia",
    category: "estrategia-comercial",
    title: "Convenios de doble tributación: cómo aprovecharlos en operaciones internacionales",
    date: "24 febrero 2026",
    publishedAt: "2026-02-24",
    readTime: "10 minutos",
    author: autor,
    featured: false,
    excerpt:
      "Los CDT distribuyen la carga tributaria entre países y pueden reducir la retención en la fuente en dividendos, servicios e intereses. Conozca requisitos, casos prácticos y errores que ponen en riesgo deducciones.",
    content: [],
  },
  {
    slug: "planeacion-tributaria-calendario-2026",
    category: "finanzas-corporativas",
    title: "Planeación tributaria 2026: cómo armar su calendario fiscal y proteger el flujo de caja",
    date: "12 febrero 2026",
    publishedAt: "2026-02-12",
    readTime: "10 minutos",
    author: autor,
    featured: false,
    excerpt:
      "Cuando el equipo contable cumple «a contrarreloj», algo falló en la planeación. Conozca beneficios, impuestos clave, tributos ambientales y cómo alinear contabilidad, tesorería y calendario tributario durante 2026.",
    content: [],
  },
  {
    slug: "tendencias-credito-acceso-financiero-pymes",
    category: "finanzas-corporativas",
    title: "Tendencias de crédito que impulsan el acceso financiero de las pymes en 2026",
    date: "02 febrero 2026",
    publishedAt: "2026-02-02",
    readTime: "9 minutos",
    author: autor,
    featured: false,
    excerpt:
      "La digitalización y las fintech están ampliando el crédito para pymes, pero la brecha de financiamiento sigue siendo enorme. Conozca tendencias, usos del crédito y cómo preparar su empresa para acceder a recursos.",
    content: [],
  },
  {
    slug: "costos-logisticos-cadena-abastecimiento-empresas",
    category: "gestion-administrativa",
    title: "Costos logísticos y cadena de abastecimiento: impactos en la rentabilidad de su negocio",
    date: "29 diciembre 2025",
    publishedAt: "2025-12-29",
    readTime: "8 minutos",
    author: autor,
    featured: false,
    excerpt:
      "Tercerizar la logística sin conocer sus rubros oculta oportunidades de ahorro. Identifique costos directos e indirectos, evalúe si conviene operar internamente o con terceros y proteja su margen.",
    content: [],
  },
  {
    slug: "ajustes-economicos-planeacion-financiera-2026",
    category: "finanzas-corporativas",
    title: "Ajustes económicos para 2026: 4 indicadores que impactan su planeación financiera",
    date: "30 diciembre 2025",
    publishedAt: "2025-12-30",
    readTime: "9 minutos",
    author: autor,
    featured: false,
    excerpt:
      "IPC, UVT, UVB y salario mínimo redefinen costos de nómina, arriendos, servicios y tributos. Conozca cómo proyectarlos antes de cerrar su presupuesto 2026 y evitar sorpresas de caja.",
    content: [],
  },
  {
    slug: "estrategias-recaudo-cartera-finanzas-empresas",
    category: "finanzas-corporativas",
    title: "Estrategias de recaudo de cartera para fortalecer la liquidez de su empresa",
    date: "16 diciembre 2025",
    publishedAt: "2025-12-16",
    readTime: "9 minutos",
    author: autor,
    featured: false,
    excerpt:
      "La liquidez que necesita puede estar en facturas pendientes. Aprenda a prevenir riesgos de crédito, gestionar cobro preventivo, recuperar cartera vencida y usar el arbitraje ejecutivo desde 2026.",
    content: [],
  },
  {
    slug: "obligaciones-financieras-cierre-anual-empresas",
    category: "finanzas-corporativas",
    title: "Obligaciones financieras empresariales: guía de cierre de año y calendario 2026",
    date: "03 diciembre 2025",
    publishedAt: "2025-12-03",
    readTime: "9 minutos",
    author: autor,
    featured: false,
    excerpt:
      "Entre ventas de fin de año y vacaciones, no pierda de vista inventarios, IVA, cesantías, matrícula mercantil y registros que vencen en los primeros meses de 2026. Arme su calendario ahora.",
    content: [],
  },
];

export const blogEmpresarialArticles = blogEmpresarialArticlesBase.map((article) => {
  const body = blogEmpresarialArticulosBody[article.slug];
  const cover = blogEmpresarialCoverImages[article.slug];
  return {
    ...article,
    ...(body
      ? {
          readTime: body.readTime ?? article.readTime,
          keyTakeaways: body.keyTakeaways,
          content: body.content,
        }
      : {}),
    ...(cover ? { coverImage: cover.src, coverImageAlt: cover.alt } : {}),
  };
});
